function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionHouse002({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "construction_x5F_house_x5F_002",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32.414",
    style: {
      enableBackground: "new 0 0 32 32.414"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 30.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 32,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 11.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "6.414,12.414 1,12.414 1,10.414 5.586,10.414 13.293,2.707 14.707,4.121  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "31,12.414 25.586,12.414 16,2.828 14.414,4.414 1,4.414 1,2.414 13.586,2.414 16,0  26.414,10.414 31,10.414  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 13,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 2.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 2.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16.041,14.788l-0.748-0.667l-3.707-3.707l4.374-4.374l0.748,0.667l3.707,3.707L16.041,14.788z  M14.414,10.414L16,12l1.586-1.586L16,8.828L14.414,10.414z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 26,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23.414,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionHouse002);
export default __webpack_public_path__ + "static/media/construction_house_002.72fc59951a0f5c41118f598e117c8423.svg";
export { ForwardRef as ReactComponent };